<template>
    <div style="padding-top: 65px;height: 100vh">
        <el-row style="height: 100vh">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="border"  style="background-color:rgb(230,230,219);z-index: 888;">


                <el-carousel class="carousel">
                    <el-carousel-item v-for="item in list" :key="item">
                        <img :src="item.url" style="width: 100%" alt="PQ">
                    </el-carousel-item>
                </el-carousel>



            </el-col>
            <el-col :span="16" class="border" style="padding: 20px ;overflow: scroll;height: 100vh">

            <el-form ref="form" :model="form"
 :rules="rules">

                    <!--                    基础数据-->
                <div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="A" prop="a">
                                <el-input  disabled="disabled"   type="number" v-model="form.a" placeholder="Please enter dataA(mm)"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="B" prop="b">
                                <el-input  disabled="disabled"  type="number" v-model="form.b" placeholder="Please enter dataB(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="C" prop="c">
                                <el-input  disabled="disabled"  type="number" v-model="form.c" placeholder="Please enter dataC(mm)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="D" prop="d">
                                <el-input  disabled="disabled"  type="number" v-model="form.d" placeholder="Please enter dataD(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="E" prop="e">
                                <el-input  disabled="disabled"  type="number" v-model="form.e" placeholder="Please enter dataE(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="F" prop="f">
                                <el-input  disabled="disabled"  type="number" v-model="form.f" placeholder="Please enter dataF(mm)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="G" prop="ginput">
                                <el-input  disabled="disabled"  type="number" v-model="form.ginput" placeholder="Please enter dataG(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="H" prop="hinput">
                                <el-input  disabled="disabled"  type="number" v-model="form.hinput" placeholder="Please enter dataH(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="I" prop="iinput">
                                <el-input  disabled="disabled"  type="number" v-model="form.iinput" placeholder="Please enter dataI(mm)" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="J" prop="jinput">
                                <el-input  disabled="disabled"  type="number" v-model="form.jinput" placeholder="Please enter dataJ(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="R1" prop="g">
                                <el-input  disabled="disabled"  type="number"  v-model="form.g" placeholder="Please enter R1(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="R2" prop="h">
                                <el-input  disabled="disabled"  type="number"  v-model="form.h" placeholder="Please enter R2(mm)" />
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="R3" prop="jj">
                                <el-input  disabled="disabled"  type="number" v-model="form.jj" placeholder="Please enter R3(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="R4" prop="rfour">
                                <el-input  disabled="disabled"  type="number"  v-model="form.rfour" placeholder="Please enter R4(mm)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="R5" prop="rfive">
                                <el-input  disabled="disabled"  type="number"  v-model="form.rfive" placeholder="Please enter R5(mm)" />
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="R6" prop="rsix">
                                <el-input  disabled="disabled"  type="number" v-model="form.rsix" placeholder="Please enter R6(mm)" />
                            </el-form-item>
                        </el-col>


                    </el-row>
                    <!--                    gap-->
                    <el-form-item label="Gap(unilateral)">
                        <el-select v-model="form.gg" placeholder="Please enter the air gap value">
                            <el-option label="None" :value="0"></el-option>
                            <el-option label="User-defined" :value="1"></el-option>

                        </el-select>
                    </el-form-item>


                    <el-row v-if="qi">
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item label="Gap(unilateral)" prop="hh">
                                    <el-input  type="number"  v-model="form.hh" placeholder="Please enter the air gap value" />
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-row>
                    <!--                    gap-->

                    <!--                    推拔倒角始-->
                    <el-form-item label="Tolerance">
                        <el-select v-model="form.ii" placeholder="Select tolerance">
                            <el-option label="None" :value="0"></el-option>
                            <el-option label="User-defined" :value="1"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row v-if="tuiba">
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item label="Chamfer length(T)" prop="i">
                                    <el-input  type="number"  v-model="form.i" placeholder="Chamfer length(mm)"  />
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="max">
                                <el-form-item label="Chamfer Angle(Z)" prop="j">
                                    <el-input  type="number"  v-model="form.j" placeholder="Chamfer Angle"  />
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-row>
                    <!--                    推拔倒角末-->
                </div>

                        <!--            父子组件传值-->
                <IfcoresTransformer ref="IfcoresTransformer" :formToIfcoresTransformer="form"/>




                </el-form>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import IfcoresTransformer from "../../components/IfcoresTransformer";

    export default {
        name: "PQ",
        components:{
            IfcoresTransformer,
        },
         metaInfo: {
            title: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<=0){
                        tip = "The value must be greater than 0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                    let tip = "";

                    if (value * 1 === 0||value * 1<0) {
                        tip = "The value must be greater than 0"
                    }else{

                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            var check2=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "The value must be greater than 0 or equal 0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }

            }
            return{
                list:[{
                    url:require("../../../assets/PQ4.png")

                }, {
                    url:require("../../../assets/PQ3.png")
                },{
                    url:require("../../../assets/PQ2.png")
                }],
                gongcha:false,
                qi:false,
                tuiba:false,
                loading:false,
                dialogVisible: false,//弹出框
                dialogVisible2: false,
                transformers:false,
                foot:true,
                form: {
                    ee:0,
                    gg:0,
                    filetype:1,
                    cao:0,
                    ii:0,
                    types:"PQ",
                    dd:"transformer",
                    g:0,
                    h:0,
                    jj:0,
                    rfour:0,
                    rfive:0,
                    rsix:0,
                    y:"H40",
                    x:""


                },
                rules:{
                    a:[
                        { required: true, message: 'Data A is required data', trigger: 'blur' },

                        {validator: check,trigger: 'blur'}

                    ],
                    b:[
                        { required: true, message: 'Data B is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据B必须为数字值'},
                        {validator: check,trigger: 'blur'}],
                    c:[
                        { required: true, message: 'Data C is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据C必须为数字值'},
                        {validator: check,trigger: 'blur'}

                    ],
                    d:[
                        { required: true, message: 'Data D is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据D必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    e:[
                        { required: true, message: 'Data E is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据E必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    f:[
                        { required: true, message: 'Data F is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    ginput:[
                        { required: true, message: 'Data G is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    hinput:[
                        { required: true, message: 'Data H is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    jinput:[
                        { required: true, message: 'Data J is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    iinput:[
                        { required: true, message: 'Data I is required data', trigger: 'blur' },
                        // {type: 'number', message: '数据F必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    g:[
                        { required: true, message: 'Data R1 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角1必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    h:[
                        { required: true, message: 'Data R2 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角2必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    jj:[
                        { required: true, message: 'Data R3 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角3必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    rfour:[
                        { required: true, message: 'Data R4 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角3必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    rfive:[
                        { required: true, message: 'Data R5 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角3必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    rsix:[
                        { required: true, message: 'Data R6 is required data', trigger: 'blur' },
                        // {type: 'number', message: '圆角3必须为数字值'},
                        {validator: check2,trigger: 'blur'}
                    ],
                    w:[
                        { required: true, message: 'Data Density is required data', trigger: 'blur' },
                        // {type: 'number', message: '密度必须为数字值'},
                        {validator: check,trigger: 'blur'}
                    ],
                    x:[
                        { required: true, message: 'Product is required data', trigger: 'blur' },

                    ],
                    y:[
                        { required: true, message: 'Materials is required data', trigger: 'blur' },

                    ],
                    z:[
                        { required: true, message: 'Company is required data', trigger: 'blur' },

                    ],
                    aa:[
                        { required: true, message: 'User is required data', trigger: 'blur' },

                    ],
                    //    气隙
                    //    气隙
                    hh:[
                        { required: true, message: 'Air gap is mandatory. If there is no air gap, fill in 0', trigger: 'blur' },
                        {validator: function (rule, value, callback) {

                                if (value) {
                                    let tip = "";
                                    if (value* 1<0){
                                        tip = "The air gap value cannot be negative"
                                    }

                                    if (tip) {
                                        callback(new Error(tip));
                                    } else {
                                        callback();
                                    }
                                }else{
                                    callback();
                                }


                            },trigger: 'blur'}
                    ],

                    //推拔倒角
                    i:[
                        { required: true, message: "Chamfering T is required. If not, please enter 0 or select 'None'", trigger: 'blur' },
                        {validator:check2,trigger: 'blur'}
                    ],
                    j:[
                        { required: true, message: "Chamfering Angle Z is required. If not, please enter 0 or select 'None'", trigger: 'blur' },
                        {validator:check2,trigger: 'blur'}
                    ],
                    k:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    l:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    m:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    n:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    o:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    p:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    q:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    r:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    s:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    t:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    u:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    v:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    gadd:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],
                    gmin:[
                        { required: true, message: 'Tolerance is a required value, please fill in 0 if there is no tolerance', trigger: 'blur' },

                    ],


                }

            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){


                    if(val.gg==0){
                        this.qi=false
                    }else{
                        this.qi=true
                    }
                    if(val.ii==0){
                        this.tuiba=false
                    }else{
                        this.tuiba=true
                    }


                },
                deep:true //true 深度监听
            }


        },
        methods: {
           replace: function (input) {
                let that=this;
                if (input.indexOf("±") != -1) {
                    that.sizeData=[];
                    that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[0],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1])
                    return that.sizeData;
                } else if (input.indexOf("+") != -1) {


                    if (input.indexOf("-")!=-1){


                        that.sizeData=[];
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                    }else {

                        that.sizeData=[];
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[1],
                            0)



                    }


                    return that.sizeData
                } else if (input.indexOf("-") != -1) {

                    that.sizeData=[];
                    if (input.indexOf("+")!=-1) {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])
                    }else{
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            0,
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                    }
                    return that.sizeData
                } else {
                    that.sizeData=[];
                    if (input.indexOf("MAX") != -1||input.indexOf("max") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }else if (input.indexOf("MIN") != -1||input.indexOf("min") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }else {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            0,0)
                    }


                    return that.sizeData

                }
            }
        }
        ,mounted(){


            let that=this;
            this.sn=this.$route.query.sn
            request.get("/product/selectOne/"+this.sn).then(res =>{

                var obj2=JSON.parse(res.data.defined)
                obj2.name=res.data.name

                that.form.x=obj2.name
                let sizeA=that.replace(obj2.A)
                let sizeB=that.replace(obj2.B)
                let sizeC=that.replace(obj2.C)
                let sizeD=that.replace(obj2.D)
                let sizeE=that.replace(obj2.E)
                let sizeF=that.replace(obj2.F)
                let sizeG=that.replace(obj2.G)
                let sizeH=that.replace(obj2.H)
                let sizeI=that.replace(obj2.I)
                let sizeJ=that.replace(obj2.J)
                that.form.a=sizeA[0]
                that.form.k=sizeA[1]
                that.form.l=sizeA[2]
                that.form.b=sizeB[0]
                that.form.m=sizeB[1]
                that.form.n=sizeB[2]
                that.form.c=sizeC[0]
                that.form.o=sizeC[1]
                that.form.p=sizeC[2]
                that.form.d=sizeD[0]
                that.form.q=sizeD[1]
                that.form.r=sizeD[2]
                that.form.e=sizeE[0]
                that.form.s=sizeE[1]
                that.form.t=sizeE[2]
                that.form.f=sizeF[0]
                that.form.u=sizeF[1]
                that.form.v=sizeF[2]
                that.form.ginput=sizeG[0]
                that.form.gadd=sizeG[1]
                that.form.gmin=sizeG[2]
                that.form.hinput=sizeH[0]
                that.form.iinput=sizeI[0]
                that.form.jinput=sizeJ[0]

            }).catch((res)=>{
            })

        }
    }
</script>

<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }


    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }
    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
</style>